import { render, staticRenderFns } from "./TheDocumentAttachments.vue?vue&type=template&id=006fbe8c&scoped=true&"
import script from "./TheDocumentAttachments.vue?vue&type=script&lang=js&"
export * from "./TheDocumentAttachments.vue?vue&type=script&lang=js&"
import style0 from "./TheDocumentAttachments.vue?vue&type=style&index=0&id=006fbe8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006fbe8c",
  null
  
)

export default component.exports